<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="username"
            label="昵称"
            width="180">
    </el-table-column>
    <el-table-column
            fixed
            prop="shareCode"
            label="用户的分享码"
            width="180">
    </el-table-column>
    <el-table-column
            prop="registerTime"
            label="注册时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="email"
            label="邮箱"
            width="180">
    </el-table-column>
    <el-table-column
            label="默认收货地址"
            min-width="300">
      <template slot-scope="scope" v-if="scope.row.defaultReceiveAddress!=null">
        {{scope.row.defaultReceiveAddress.provinceName}}{{scope.row.defaultReceiveAddress.cityName}}{{scope.row.defaultReceiveAddress.countyName}}{{scope.row.defaultReceiveAddress.detailInfo}}
      </template>
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "userTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$router.push("/user/data/"+id)
      },
    },
    created() {
      // for (let i = 0;i<this.tableData;i++){
      //   this.tableData[i].defaultReceiveAddressInfo = this.tableData.defaultReceiveAddress.provinceName +
      //     this.tableData.defaultReceiveAddress.cityName +
      //     this.tableData.defaultReceiveAddress.countyName +
      //     this.tableData.defaultReceiveAddress.detailInfo;
      // }
      //更新用户的类型
      // for (let i = 0;i<this.tableData.length;i++){
      //   if (this.tableData[i].umsClassify==1){
      //     this.tableData[i].umsClassify=='普通会员'
      //   }else {
      //     this.tableData[i].umsClassify=='普通会员'
      //   }
      // }
    },
  }
</script>

<style scoped>
  .el-table thead{
    color: black;
  }
</style>
